import React, { useState, useEffect } from "react";
import BaseForm from "../../app/components/BaseForm";
import Input from "../../app/components/Input";
import Select from "../../app/components/Select";
import CheckBox from "../../app/components/CheckBox";

const AddGraphic = ({ isOpen, onClose, onSubmit }) => {
  const [formData, setFormData] = useState({
    titulo: '',
    tipo: '',
    metrica: '',
    linha: '',
    coluna: '',
    fases: [],
  });

  useEffect(() => {
    setFormData({
      titulo: '',
      tipo: '',
      metrica: '',
      linha: '',
      coluna: '',
      fases: [],
    });
  }, [isOpen]);

  const handleChange = (eOrValue, fieldName) => {
    if (typeof eOrValue === 'object' && eOrValue !== null && 'value' in eOrValue) {
      setFormData(prev => ({
        ...prev,
        [fieldName]: eOrValue.value,
      }));
    } else {
      const { name, value } = eOrValue.target;
      setFormData(prev => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormData((prev) => {
      const updatedFases = checked
        ? [...prev.fases, name]
        : prev.fases.filter((f) => f !== name);
      return {
        ...prev,
        fases: updatedFases,
      };
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (onSubmit && typeof onSubmit === 'function') {
      onSubmit(formData);
    }
  };

  const typeOptions = [
    { value: 'linha', label: 'Linha' },
    { value: 'barra', label: 'Barra' },
    { value: 'area', label: 'Área' },
    { value: 'pizza', label: 'Pizza' },
  ];

  const commonOptions = [
    { value: 'id', label: 'ID' },
    { value: 'fase', label: 'Fase' },
    { value: 'responsavel', label: 'Responsável' },
    { value: 'nome_cliente', label: 'Nome do Cliente' },
  ];

  const metricsOptions = [
    { value: 'id', label: 'ID (count)' },
    { value: 'email', label: 'Email (count)' },
    { value: 'telefone', label: 'Telefone (count)' },
    { value: 'nome_cliente', label: 'Nome do Cliente (count)' },
  ];

  return (
    <BaseForm
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={handleSubmit}
      title="Adicionar Gráfico"
      submitButtonText="Salvar"
      cancelButtonText="Fechar"
    >
      <div>
        <Input
          label='Título do Gráfico'
          name='titulo'
          value={formData.titulo}
          onChange={handleChange}
        />
        <div className="grid grid-cols-2 gap-4">
          <Select
            label='Tipo de Gráfico'
            name='tipo'
            options={typeOptions}
            value={formData.tipo}
            onChange={(value) => handleChange(value, 'tipo')}
          />
          <Select
            label='Métricas'
            name='metrica'
            options={metricsOptions}
            value={formData.metrica}
            onChange={(value) => handleChange(value, 'metrica')}
          />
          <Select
            label='Linha'
            name='linha'
            options={commonOptions}
            value={formData.linha}
            onChange={(value) => handleChange(value, 'linha')}
          />
          <Select
            label='Coluna'
            name='coluna'
            options={commonOptions}
            value={formData.coluna}
            onChange={(value) => handleChange(value, 'coluna')}
          />
        </div>
        <div>
          <h2 className="mt-4 font-semibold">Fases</h2>
          <div className="grid grid-cols-3 text-sm mt-2">    
            <CheckBox title='Lead quente' name='lead_quente' onChange={handleCheckboxChange} checked={formData.fases.includes('lead_quente')} />
            <CheckBox title='Negociação' name='negociacao' onChange={handleCheckboxChange} checked={formData.fases.includes('negociacao')} />
            <CheckBox title='Abertura vendida' name='abertura_vendida' onChange={handleCheckboxChange} checked={formData.fases.includes('abertura_vendida')} />
            <CheckBox title='Ganho (falta contrato)' name='ganho' onChange={handleCheckboxChange} checked={formData.fases.includes('ganho')} />
            <CheckBox title='Contrato Assinado' name='contrato_assinado' onChange={handleCheckboxChange} checked={formData.fases.includes('contrato_assinado')} />
            <CheckBox title='Perdido' name='perdido' onChange={handleCheckboxChange} checked={formData.fases.includes('perdido')} />
            <CheckBox title='Não Convertido' name='nao_convertido' onChange={handleCheckboxChange} checked={formData.fases.includes('nao_convertido')} />
            <CheckBox title='Arquivo' name='arquivo' onChange={handleCheckboxChange} checked={formData.fases.includes('arquivo')} />
          </div>
        </div>
      </div>
    </BaseForm>
  );
};

export default AddGraphic;
